// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"

import {updateBabyState} from "../../actions/babies"
import type {Baby, BabyState, Dispatch} from "../../types"
import {BABY_STATES} from "../../constants"

type Props = {
  +t: any,
  +baby: Baby,
  +dispatch: Dispatch,
  +handleCloseModal: () => void,
  +handleAfterOpen: () => void,
  reload: boolean,
}

type BabyStateState = {
  +reason: string,
  +state: BabyState,
}

type State = {
  +babyState: ?BabyStateState,
}

const initialBabyState = (state: BabyState, reason = "") => ({state, reason})

class UpdateStateModal extends React.Component<Props, State> {
  handleSave: () => void
  handleInputChange: (SyntheticInputEvent<HTMLTextAreaElement>) => void

  state = {
    babyState: null,
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      babyState: initialBabyState(this.props.baby.state),
    }

    this.handleSave = this.handleSave.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleInputChange(e: SyntheticInputEvent<HTMLTextAreaElement>) {
    const {name} = e.currentTarget
    this.setState({
      babyState: {...this.state.babyState, [name]: e.currentTarget.value},
    })
  }

  handleSave() {
    const {babyState} = this.state
    if (!babyState) {
      return null
    }
    const {state, reason} = babyState
    const {dispatch, baby, reload} = this.props
    dispatch(updateBabyState(baby.token, state, reason))
    if (reload) setTimeout(() => window.location.reload(), 250)
    this.props.handleCloseModal()
  }

  render() {
    const {t} = this.props
    const {babyState} = this.state
    return (
      <Modal
        className="modal-dialog modal-sm"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.handleCloseModal}
        onAfterOpen={this.props.handleAfterOpen}
        contentLabel={t("modal.updateState.title")}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("modal.updateState.title")}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("modal.close")}
              onClick={this.props.handleCloseModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <div className="form-group">
              <select
                className="form-control"
                autoFocus={true}
                name="state"
                value={babyState ? babyState.state : null}
                onChange={this.handleInputChange}
              >
                {BABY_STATES.map((bs) => (
                  <option key={`baby-state-${bs}`} value={bs}>
                    {t(`babyCard.babyState.${bs}`)}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <textarea
                className="form-control"
                name="reason"
                maxLength={255}
                value={babyState ? babyState.reason : ""}
                onChange={this.handleInputChange}
              />
            </div>
            <button className="btn btn-primary" onClick={this.handleSave}>
              {t("modal.save")}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(connect()(UpdateStateModal))
